import cn from 'classnames';
import styles from './Body.module.scss';

export interface BodyProps {
  children?: React.ReactNode;
  className?: string;
}

const Body: React.FC<BodyProps> = ({ children, className }) => (
  <div className={cn(styles.root, className)}>{children}</div>
);

export default Body;
